// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1STYF","addWidgetButton":"Header_addWidgetButton__2MKVm","dashboardTabs":"Header_dashboardTabs__1M-zS","active":"Header_active__2-116"};